<template>
  <svg class="svg-icon"
       :style="svgStyle"
       :viewBox="viewBox"
       preserveAspectRatio="xMidYMid meet"
       aria-hidden="true"
  >
    <use :xlink:href="`#${name}`" />
  </svg>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Icon',
  data() {
    return {
      viewBox: null,
    };
  },
  props: {
    name: { type: String, required: true },
    width: [String, Number],
    height: [String, Number],
    size: { type: [String, Number] }
  },
  computed: {
    svgStyle() {
      // 若只傳 width → height 自動維持比例 (透過 aspect-ratio)
      // 若只傳 height → width 自動維持比例
      // 若有 size , 強制寬高比 1:1, 若都沒有, 預設寬24px
      const w = this.width ? this.addUnit(this.width) : this.size ? this.addUnit(this.size) : this.addUnit(24);
      const h = this.height ? this.addUnit(this.height) : this.size ? this.addUnit(this.size) : 'auto';

      return {
        width: w,
        height: h,
        aspectRatio: 'auto', // 保留 viewBox 比例（需要 svg 原始有 viewBox）
        fill: 'currentColor',
        verticalAlign: 'middle',
        display: 'inline-block'
      };
    }
  },
  components: {
  },
  mounted() {
    // 嘗試從 <symbol> 取出原始 viewBox，維持比例
    const symbol = document.querySelector(`#${this.name}`);
    if (symbol && symbol.getAttribute('viewBox')) {
      this.viewBox = symbol.getAttribute('viewBox');
    }
  },
  methods: {
    addUnit(v) {
      return typeof v === 'number' ? `${v}px` : v;
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
